export const getStartObject = () => window.start;
